/**
  advisorFeeRate: number,
  advisorDefaultFeeRate: number,
  cyCustodianFees: {
    [custodianId]: fee
  },
  cyPlatformFees: fee,
  portfolioAdvisorFeeRates: {
    [portfolioId]: rate,
  },
  portfolioCustodianFees: {
    [portfolioId]: {
      [custodianId]: fee
    }
  },
  portfolioPlatformFees: {
    [portfolioId]: fee
  },
  userCustodianFees: {
    [userID]: {
      [custodianId]: fee
    }
  },
  userPlatformFees: {
    [userId]: fee
  },
  */

const initialState = {
  advisorDefaultFeeRate: undefined,
  advisorFeeRate: undefined,
  cyCustodianFees: {},
  cyPlatformFees: {},
  loading: true,
  portfolioAdvisorFeeRates: {},
  portfolioCustodianFees: {},
  portfolioPlatformFees: {},
  updateError: null,
  userCustodianFees: {},
  userPlatformFees: {},
};

export default function fee(state = initialState, action) {
  let newState;

  switch (action.type) {
    case "LOAD_USER_APPLICATION_STATE_SUCCESS":
      const userAppStatePayload = Object.assign(
        {
          advisorFeeRate: undefined,
          advisorDefaultFeeRate: undefined,
          cyCustodianFees: {},
          cyPlatformFees: [],
          userCustodianFees: {},
          userId: null,
          userPlatformFees: [],
        },
        action.payload
      );

      newState = Object.assign(state, {
        advisorFeeRate: userAppStatePayload.advisorFeeRate,
        advisorDefaultFeeRate: userAppStatePayload.advisorDefaultFeeRate,
      });

      Object.keys(userAppStatePayload.cyCustodianFees).forEach(function (
        custodianId
      ) {
        const newCustodianFeesState = Object.assign(
          {},
          newState.cyCustodianFees
        );
        const fees = userAppStatePayload.cyCustodianFees[custodianId];
        newCustodianFeesState[custodianId] = fees;
        newState.cyCustodianFees = newCustodianFeesState;
      });

      newState.cyPlatformFees = userAppStatePayload.cyPlatformFees;

      newState.userCustodianFees = Object.assign(
        {},
        newState.userCustodianFees
      );
      newState.userCustodianFees[userAppStatePayload.userId] =
        userAppStatePayload.userCustodianFees;

      newState.userPlatformFees = Object.assign({}, newState.userPlatformFees);
      newState.userPlatformFees[userAppStatePayload.userId] =
        userAppStatePayload.userPlatformFees;

      return {
        ...newState,
        loading: false,
        updateError: null,
      };
    case "PORTFOLIO_FETCH_SUCCESS": {
      const portfolio = Object.assign(
        {
          uuid: null,
          custodianId: null,
          platformFees: [],
          custodianFees: [],
        },
        action.payload.data
      );

      newState = Object.assign({}, state);
      newState.portfolioCustodianFees = Object.assign(
        {},
        newState.portfolioCustodianFees
      );
      newState.portfolioCustodianFees[portfolio.uuid] = Object.assign(
        {},
        newState.portfolioCustodianFees[portfolio.uuid]
      );

      if (portfolio.CustodianId) {
        newState.portfolioCustodianFees[portfolio.uuid][portfolio.CustodianId] =
          portfolio.custodianFees;
      }

      newState.portfolioPlatformFees = Object.assign(
        {},
        newState.portfolioPlatformFees
      );
      newState.portfolioPlatformFees[portfolio.uuid] = portfolio.platformFees;

      newState.portfolioAdvisorFeeRates = Object.assign(
        {},
        newState.portfolioAdvisorFeeRates
      );
      newState.portfolioAdvisorFeeRates[portfolio.uuid] = portfolio.advisorFee;

      newState.loading = false;
      newState.updateError = false;
      return newState;
    }
    case "UPDATE_FEES_ADVISOR_RATE_DEFAULT_FAIL":
    case "UPDATE_FEES_ADVISOR_RATE_FAIL":
    case "UPDATE_FEES_ADVISOR_CUSTODIAN_FAIL":
    case "UPDATE_FEES_ADVISOR_PLATFORM_FAIL":
    case "UPDATE_FEES_DEFAULT_CUSTODIAN_FAIL":
    case "UPDATE_FEES_CUSTODIAN_FAIL":
    case "UPDATE_FEES_DEFAULT_PLATFORM_FAIL":
    case "UPDATE_FEES_HOUSEHOLD_CUSTODIAN_FAIL":
      return {
        ...state,
        loading: false,
        updateError: action.payload,
      };
    case "UPDATE_FEES_ADVISOR_RATE_DEFAULT_REQUESTED":
    case "UPDATE_FEES_ADVISOR_RATE_REQUESTED":
    case "UPDATE_FEES_ADVISOR_CUSTODIAN_REQUESTED":
    case "UPDATE_FEES_ADVISOR_PLATFORM_REQUESTED":
    case "UPDATE_FEES_DEFAULT_CUSTODIAN_REQUESTED":
    case "UPDATE_FEES_CUSTODIAN_REQUESTED":
    case "UPDATE_FEES_DEFAULT_PLATFORM_REQUESTED":
    case "UPDATE_FEES_HOUSEHOLD_CUSTODIAN_REQUESTED":
      return {
        ...state,
        loading: false,
        updateError: null,
      };
    case "UPDATE_FEES_ADVISOR_RATE_SUCCESS":
      return {
        ...state,
        loading: false,
        updateError: null,
        advisorFeeRate: action.payload.advisorFeeRate,
      };
    case "UPDATE_FEES_ADVISOR_RATE_DEFAULT_SUCCESS":
      return {
        ...state,
        loading: false,
        updateError: null,
        advisorDefaultFeeRate: action.payload.advisorDefaultFeeRate,
      };
    // update fee
    case "UPDATE_FEES_ADVISOR_CUSTODIAN_SUCCESS":
      const advisorCustodianPayload = Object.assign(
        {
          custodianId: null,
          userId: null,
          fees: [],
        },
        action.payload
      );
      newState = Object.assign({}, state);
      newState.userCustodianFees = Object.assign(
        {},
        newState.userCustodianFees
      );
      newState.userCustodianFees[advisorCustodianPayload.userId] =
        Object.assign(
          {},
          newState.userCustodianFees[advisorCustodianPayload.userId]
        );
      newState.userCustodianFees[advisorCustodianPayload.userId][
        advisorCustodianPayload.custodianId
      ] = advisorCustodianPayload.fees;
      newState.loading = false;
      newState.updateError = false;

      return newState;
    // removing a custodian
    case "UPDATE_FEES_CUSTODIAN_SUCCESS":
      const removeCustodianPayload = Object.assign(
        {
          custodianId: null,
          fees: [],
          userId: null,
        },
        action.payload
      );

      newState = Object.assign({}, state);
      newState.userCustodianFees = Object.assign(
        {},
        newState.userCustodianFees
      );
      newState.userCustodianFees[removeCustodianPayload.userId] = Object.assign(
        {},
        newState.userCustodianFees[removeCustodianPayload.userId]
      );

      delete newState.userCustodianFees[removeCustodianPayload.userId][
        removeCustodianPayload.custodianId
      ];

      newState.loading = false;
      newState.updateError = false;
      return newState;
    case "UPDATE_FEES_ADVISOR_PLATFORM_SUCCESS":
      const advisorPlatformPayload = Object.assign(
        {
          userId: null,
          fees: [],
        },
        action.payload
      );

      newState = Object.assign({}, state);
      newState.userPlatformFees = Object.assign({}, newState.userPlatformFees);
      newState.userPlatformFees[advisorPlatformPayload.userId] =
        advisorPlatformPayload.fees;

      newState.loading = false;
      newState.updateError = false;
      return newState;
    case "UPDATE_FEES_DEFAULT_CUSTODIAN_SUCCESS":
      const defaultCustodianPayload = Object.assign(
        {
          fees: [],
          custodianId: null,
        },
        action.payload
      );

      newState = Object.assign({}, state);
      newState.cyCustodianFees = Object.assign({}, newState.cyCustodianFees);
      newState.cyCustodianFees[defaultCustodianPayload.custodianId] =
        defaultCustodianPayload.fees;

      newState.loading = false;
      newState.updateError = false;
      return newState;
    case "UPDATE_FEES_DEFAULT_PLATFORM_SUCCESS":
      const defaultPlatformPayload = Object.assign(
        {
          fees: [],
        },
        action.payload
      );

      return Object.assign({}, state, {
        cyPlatformFees: defaultPlatformPayload.fees,
        loading: false,
        updateError: null,
      });
    case "UPDATE_FEES_ADVISOR_RATE_PORTFOLIO_SUCCESS": {
      const portfolio = Object.assign(
        {
          portfolioId: null,
          advisorDefaultFeeRate: null,
        },
        action.payload
      );

      newState = Object.assign({}, state);
      newState.portfolioAdvisorFeeRates = Object.assign(
        {},
        newState.portfolioAdvisorFeeRates
      );
      newState.portfolioAdvisorFeeRates[portfolio.portfolioId] =
        portfolio.advisorDefaultFeeRate;

      newState.loading = false;
      newState.updateError = false;
      return newState;
    }
    case "USER_FETCH_SUCCESS":
      const user = Object.assign(
        {
          id: null,
          platformFees: [],
          custodianFees: {},
        },
        action.payload.user
      );

      newState = Object.assign({}, state);
      newState.userCustodianFees = Object.assign(newState.userCustodianFees);
      newState.userCustodianFees[user.id] = user.custodianFees;

      newState.userPlatformFees = Object.assign(newState.userPlatformFees);
      newState.userPlatformFees[user.id] = user.platformFees;

      newState.loading = false;
      newState.updateError = false;
      return newState;
    case "HOUSEHOLD_DETAIL_SUCCESS": {
      const portfolios = action.payload.data.Portfolios;

      newState = Object.assign({}, state);
      newState.portfolioCustodianFees = Object.assign(
        {},
        newState.portfolioCustodianFees
      );
      portfolios.forEach((portfolio) => {
        newState.portfolioCustodianFees[portfolio.uuid] = Object.assign(
          {},
          newState.portfolioCustodianFees[portfolio.uuid]
        );
        if (portfolio.CustodianId) {
          newState.portfolioCustodianFees[portfolio.uuid][
            portfolio.CustodianId
          ] = portfolio.custodianFees;
        }

        newState.portfolioPlatformFees = Object.assign(
          {},
          newState.portfolioPlatformFees
        );
        newState.portfolioPlatformFees[portfolio.uuid] = portfolio.platformFees;

        newState.portfolioAdvisorFeeRates = Object.assign(
          {},
          newState.portfolioAdvisorFeeRates
        );
        newState.portfolioAdvisorFeeRates[portfolio.uuid] =
          portfolio.advisorFee;
      });

      newState.loading = false;
      newState.updateError = false;
      return newState;
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/fee.reducer.js